import React, { useState } from 'react';
import Backdrop from '@material-ui/core/Backdrop';
import CircularProgress from '@material-ui/core/CircularProgress';
import { makeStyles, createStyles, Theme } from '@material-ui/core/styles';

const useStyles = makeStyles((theme: Theme) =>
	createStyles({
		backdrop: {
			zIndex: theme.zIndex.drawer + 1,
			color: '#fff',
		},
	})
);

export const IsLoadingHOC = (WrappedComponent: any) => {
	function HOC(props: any) {
		const [isLoading, setLoading] = useState(false);

		const setLoadingState = (isComponentLoading: boolean) => {
			console.log('setting loading to ', isComponentLoading)
            setLoading(isComponentLoading);
		};

		const classes = useStyles();

		return (
			<>
				{isLoading && (
					<Backdrop className={classes.backdrop} open={true}>
						<CircularProgress color='inherit' />
					</Backdrop>
				)}
				<WrappedComponent {...props} setLoading={setLoadingState} />
			</>
		);
	}
	return HOC;
};

export default IsLoadingHOC;
